import { endOfMonth } from 'date-fns/endOfMonth';

export const getWidthInPercentage = (activeMonths: Date[], date1: Date, date2: Date) => {
  const firstDateTime = activeMonths[0].getTime();
  const lastDateTime = endOfMonth(activeMonths[activeMonths.length - 1]).getTime();
  const width = ((date2.getTime() - date1.getTime()) / (lastDateTime - firstDateTime)) * 100;

  return width > 0 ? width : 0;
};
